import React from 'react'

export function IconMasterCardSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
      <path
        d="M12.4736 -0.00756836C15.2492 -0.00743581 17.499 2.206 17.499 4.93579C17.4988 7.66536 15.249 9.87804 12.4736 9.87817C11.2291 9.87817 10.0907 9.43247 9.21289 8.69556C8.33521 9.43215 7.19735 9.87817 5.95312 9.87817C3.17765 9.87799 0.927734 7.66457 0.927734 4.93481C0.927999 2.20528 3.17781 -0.00737956 5.95312 -0.00756836C7.19713 -0.00756836 8.33528 0.437721 9.21289 1.17407C10.0906 0.437406 11.2293 -0.00756836 12.4736 -0.00756836Z"
        fill="#ED0006"
      />
      <path
        d="M12.4727 -0.00756836C15.2483 -0.00756836 17.499 2.20592 17.499 4.93579C17.4988 7.66544 15.2481 9.87817 12.4727 9.87817C11.2281 9.87813 10.0906 9.43154 9.21289 8.69458C10.2926 7.78807 10.9784 6.44139 10.9785 4.93579C10.9785 3.42977 10.293 2.08166 9.21289 1.17505C10.0906 0.438338 11.2284 -0.00752598 12.4727 -0.00756836Z"
        fill="#F9A000"
      />
      <path
        d="M9.21289 1.17432C10.2932 2.08085 10.9784 3.42896 10.9785 4.93506C10.9785 6.44114 10.293 7.78919 9.21289 8.6958C8.13284 7.7892 7.44727 6.44105 7.44727 4.93506C7.44738 3.42905 8.13272 2.08085 9.21289 1.17432Z"
        fill="#FF5E00"
      />
    </svg>
  )
}
